import { useCallback, useEffect, useRef, useState } from "react";
import defaultLogo from "../../assets/logo.png";
import s from "./splash.module.css";

const TIMING = {
  text: 900,
  exit: 2100,
  done: 2600,
};

const SAFETY_DONE_MS = 4000;

export function SplashScreenStatic() {
  return (
    <div className={s.splashStatic} role="status" aria-label="Загрузка" />
  );
}

export default function SplashScreen({
  branding,
  onComplete,
  safetyTimeout = false,
  defaultTagline = "Ваш спортивный клуб",
}) {
  const [phase, setPhase] = useState("logo");
  const onCompleteRef = useRef(onComplete);
  const finishedRef = useRef(false);
  onCompleteRef.current = onComplete;

  const logoSrc = branding?.logoSrc || defaultLogo;
  const brandTitle = branding?.brandTitle || "";
  const tagline = branding?.tagline || defaultTagline;
  const splashBgStyle = branding?.splashBgStyle || undefined;
  const personalized = Boolean(branding?.personalized);

  const finish = useCallback(() => {
    if (finishedRef.current) return;
    finishedRef.current = true;
    onCompleteRef.current?.();
  }, []);

  useEffect(() => {
    const toText = setTimeout(() => setPhase("text"), TIMING.text);
    const toExit = setTimeout(() => setPhase("exit"), TIMING.exit);
    const done = setTimeout(finish, TIMING.done);
    const safety = safetyTimeout
      ? setTimeout(finish, SAFETY_DONE_MS)
      : undefined;
    return () => {
      clearTimeout(toText);
      clearTimeout(toExit);
      clearTimeout(done);
      if (safety) clearTimeout(safety);
    };
  }, [finish, safetyTimeout]);

  return (
    <div
      className={s.splash}
      data-phase={phase}
      data-personalized={personalized ? "1" : "0"}
      role="status"
      aria-live="polite"
      aria-label="Загрузка"
    >
      <div className={s.splashBg} style={splashBgStyle} aria-hidden />
      <div className={s.splashInner}>
        <div className={s.splashLogoWrap}>
          <img src={logoSrc} alt="" className={s.splashLogo} />
        </div>
        <div className={s.splashMeta}>
          {brandTitle ? <h1 className={s.splashBrand}>{brandTitle}</h1> : null}
          {tagline ? <p className={s.splashTagline}>{tagline}</p> : null}
        </div>
      </div>
    </div>
  );
}
